import React, { useState } from 'react';
import icon from '../assets/icon.png';
import { Buttons } from '../components/Buttons';
import { Link } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import PublicListingSection from '../components/PublicListingSection';

const residentialTypes = [
  'Single-family homes',
  'Apartments & condominiums',
  'Townhomes',
  'Duplexes & multi-unit residences',
];

const residentialExpect = [
  'Professionally maintained properties',
  'Responsive management and support',
  'Easy online application process',
  'Transparent lease agreements',
  'Secure online rent payment options',
];

const commercialTypes = [
  'Office spaces',
  'Retail storefronts',
  'Shopping centers',
  'Mixed-use properties',
];

const commercialBenefits = [
  'Prime Bay Area locations',
  'Flexible lease terms',
  'Professionally managed properties',
  'Ongoing maintenance support',
  'Strategic business positioning',
];

const steps = [
  { num: '01', title: 'Search Properties', detail: 'Browse available listings based on your preferred location, budget, and property type.' },
  { num: '02', title: 'Schedule a Viewing', detail: 'Tour properties with our team and get detailed insights before making a decision.' },
  { num: '03', title: 'Submit Application', detail: 'Complete our streamlined application and screening process.' },
  { num: '04', title: 'Lease Signing', detail: 'Review and sign a clear, legally compliant lease agreement.' },
  { num: '05', title: 'Move-In', detail: 'Enjoy a smooth move-in process with ongoing support from our management team.' },
];

const whyRent = [
  'Professionally managed properties',
  'Transparent leasing process',
  'Fast response times',
  'Well-maintained homes and spaces',
  'Trusted local expertise',
];

const Rent = () => {
  const [activeTab] = useState('commercial');

  return (
    <div className="w-full bg-black">

      {/* Hero */}
      <div className="w-full bg-[#1A1A1A] px-[4rem] py-[5rem] flex flex-col items-center gap-[1rem] text-center border-b border-[#262626]">
        <div className="flex gap-[5px] justify-center">
          <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
          <p className="text-[18px] text-white">Your Trusted Source for Quality Rentals in California</p>
        </div>
        <h1 className="text-[55px] leading-tight font-bold text-gradient">Find Rental Properties in San Francisco & The Bay Area</h1>
        <p className="text-white text-[18px] font-light max-w-[900px]">
          At Millennium Realty, we connect tenants with high-quality rental properties across San Francisco and the greater Bay Area. Whether you're searching for a modern apartment, a single-family home, or a commercial lease space, our team makes the process simple, transparent, and efficient.
        </p>
        {/* <a
          href={featuredProperty.link}
          target="_blank"
          rel="noreferrer"
          className="featured-property-card group mt-[1.5rem] w-full max-w-[820px] overflow-hidden rounded-[18px] border border-[#3A3320] bg-[#111] text-left shadow-[0_30px_80px_rgba(0,0,0,0.35)]"
        >
          <div className="relative flex flex-col sm:flex-row">
            <div className="relative h-[220px] sm:h-auto sm:w-[42%] overflow-hidden bg-[#222]">
              <img
                src={featuredProperty.image}
                alt={featuredProperty.title}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent sm:bg-gradient-to-r sm:from-transparent sm:via-black/10 sm:to-black/70" />
              <span className="absolute left-[1rem] top-[1rem] rounded-full border border-white/20 bg-black/60 px-[0.9rem] py-[0.35rem] text-[13px] font-semibold uppercase tracking-[0.12em] text-white backdrop-blur-md">
                Featured
              </span>
            </div>
            <div className="relative flex flex-1 flex-col gap-[1rem] p-[1.4rem] sm:p-[1.8rem]">
              <div className="absolute right-[1.25rem] top-[1.25rem] h-[42px] w-[42px] rounded-full border border-[#EEC24B]/45 bg-[#EEC24B]/10 text-[#EEC24B] transition-all duration-300 group-hover:bg-[#EEC24B] group-hover:text-black">
                <FaExternalLinkAlt className="mx-auto mt-[12px]" size={16} />
              </div>
              <div className="flex items-center gap-[0.55rem] pr-[3.4rem] text-[#EEC24B]">
                <FaMapMarkerAlt size={15} className="flex-shrink-0" />
                <span className="text-[14px] font-semibold uppercase tracking-[0.16em]">Opportunity</span>
              </div>
              <h2 className="max-w-[520px] text-[28px] font-bold leading-tight text-white sm:text-[34px]">
                {featuredProperty.title}
              </h2>
              <p className="max-w-[560px] text-[16px] font-light leading-relaxed text-[#BDBDBD]">
                View the latest listing details, availability, and property information.
              </p>
              <div className="flex items-center gap-[0.8rem] pt-[0.35rem]">
                <span className="h-[1px] w-[52px] bg-[#EEC24B]" />
                <span className="text-[15px] font-semibold text-white transition-colors duration-300 group-hover:text-[#EEC24B]">
                  Open property listing
                </span>
              </div>
            </div>
          </div>
        </a> */}
      </div>

      <PublicListingSection
        listingType="rent"
        eyebrow="Live Rental Inventory"
        title="Published Rent / Lease Listings"
        description="Browse current rental and lease properties added by the admin team."
      />

      {/* Tab Navigation */}
      {/* <div className="w-full bg-black px-[4rem] pt-[4rem] pb-0 flex justify-center border-b border-[#262626]">
        <div className="flex gap-[0]">
          <button
            onClick={() => setActiveTab('residential')}
            className={`py-[1rem] px-[3rem] text-[18px] font-semibold transition-all duration-300 border-b-2 ${activeTab === 'residential' ? 'text-[#EEC24B] border-[#EEC24B]' : 'text-white border-transparent hover:text-[#EEC24B]'}`}
          >
            Residential
          </button>
          <button
            onClick={() => setActiveTab('commercial')}
            className={`py-[1rem] px-[3rem] text-[18px] font-semibold transition-all duration-300 border-b-2 ${activeTab === 'commercial' ? 'text-[#EEC24B] border-[#EEC24B]' : 'text-white border-transparent hover:text-[#EEC24B]'}`}
          >
            Commercial
          </button>
        </div>
      </div> */}

      {/* Tab Content */}
      {activeTab === 'residential' && (
        <div className="w-full px-[4rem] py-[5rem] bg-black border-b border-[#262626]">
          <div className="max-w-[1440px] mx-auto flex flex-wrap gap-[4rem] justify-between">
            <div className="flex-1 min-w-[280px] flex flex-col gap-[1.5rem]">
              <div className="flex gap-[5px]">
                <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
                <p className="text-[18px] text-white">Available Properties</p>
              </div>
              <h2 className="text-[45px] font-bold text-gradient">Residential Rentals in the Bay Area</h2>
              <p className="text-white text-[18px] font-light">
                We offer a wide selection of residential rental properties, including:
              </p>
              <ul className="flex flex-col gap-[0.8rem]">
                {residentialTypes.map((item, i) => (
                  <li key={i} className="flex items-center gap-[0.8rem]">
                    <FaCheckCircle className="text-[#EEC24B] flex-shrink-0" size={18} />
                    <p className="text-white text-[18px] font-light">{item}</p>
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex-1 min-w-[280px] flex flex-col gap-[1.5rem]">
              <h3 className="text-[35px] font-bold text-gradient">What You Can Expect</h3>
              <ul className="flex flex-col gap-[0.8rem]">
                {residentialExpect.map((item, i) => (
                  <li key={i} className="flex items-start gap-[0.8rem] bg-[#1A1A1A] border border-[#262626] rounded-lg px-[1.5rem] py-[1rem] hover:border-[#EEC24B] transition-all duration-300">
                    <FaCheckCircle className="text-[#EEC24B] mt-1 flex-shrink-0" size={18} />
                    <p className="text-white text-[17px] font-light">{item}</p>
                  </li>
                ))}
              </ul>
              <p className="text-white text-[17px] font-light">
                Our goal is to provide tenants with a seamless rental experience — from property search to move-in and beyond.
              </p>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'commercial' && (
        <div className="w-full px-[4rem] py-[5rem] bg-black border-b border-[#262626]">
          <div className="max-w-[1440px] mx-auto flex flex-wrap gap-[4rem] justify-between">
            <div className="flex-1 min-w-[280px] flex flex-col gap-[1.5rem]">
              <div className="flex gap-[5px]">
                <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
                <p className="text-[18px] text-white">Business Spaces</p>
              </div>
              <h2 className="text-[45px] font-bold text-gradient">Commercial Lease Opportunities</h2>
              <p className="text-white text-[18px] font-light">
                Looking for a space to grow your business? We offer commercial lease options across the Bay Area, including:
              </p>
              <ul className="flex flex-col gap-[0.8rem]">
                {commercialTypes.map((item, i) => (
                  <li key={i} className="flex items-center gap-[0.8rem]">
                    <FaCheckCircle className="text-[#EEC24B] flex-shrink-0" size={18} />
                    <p className="text-white text-[18px] font-light">{item}</p>
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex-1 min-w-[280px] flex flex-col gap-[1.5rem]">
              <h3 className="text-[35px] font-bold text-gradient">Commercial Leasing Benefits</h3>
              <ul className="flex flex-col gap-[0.8rem]">
                {commercialBenefits.map((item, i) => (
                  <li key={i} className="flex items-start gap-[0.8rem] bg-[#1A1A1A] border border-[#262626] rounded-lg px-[1.5rem] py-[1rem] hover:border-[#EEC24B] transition-all duration-300">
                    <FaCheckCircle className="text-[#EEC24B] mt-1 flex-shrink-0" size={18} />
                    <p className="text-white text-[17px] font-light">{item}</p>
                  </li>
                ))}
              </ul>
              <p className="text-white text-[17px] font-light">
                Our team works closely with business owners to find locations that support long-term growth and visibility.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Leasing Process */}
      <div className="w-full px-[4rem] py-[5rem] bg-[#1A1A1A] border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-col gap-[3rem]">
          <div className="text-center flex flex-col gap-[1rem]">
            <div className="flex gap-[5px] justify-center">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Step-by-Step</p>
            </div>
            <h2 className="text-[45px] font-bold text-gradient">Simple & Efficient Leasing Process</h2>
          </div>
          <div className="flex flex-wrap gap-[1.5rem] justify-center">
            {steps.map((step, i) => (
              <div key={i} className="flex-1 min-w-[220px] max-w-[280px] bg-[#111] border border-[#262626] rounded-lg p-[2rem] flex flex-col gap-[1rem] hover:border-[#EEC24B] transition-all duration-300">
                <span className="text-gradient text-[42px] font-bold">{step.num}</span>
                <h3 className="text-white text-[20px] font-bold">{step.title}</h3>
                <p className="text-[#999] text-[16px] font-light">{step.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Why Rent */}
      <div className="w-full px-[4rem] py-[5rem] bg-black border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-col items-center gap-[3rem]">
          <div className="text-center flex flex-col gap-[1rem]">
            <div className="flex gap-[5px] justify-center">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Our Commitment</p>
            </div>
            <h2 className="text-[45px] font-bold text-gradient">Why Rent with Millennium Realty?</h2>
          </div>
          <div className="flex flex-wrap gap-[1.5rem] justify-center w-full">
            {whyRent.map((item, i) => (
              <div key={i} className="flex items-center gap-[0.8rem] bg-[#1A1A1A] border border-[#262626] rounded-lg px-[2rem] py-[1.2rem] hover:border-[#EEC24B] transition-all duration-300">
                <FaCheckCircle className="text-[#EEC24B] flex-shrink-0" size={20} />
                <p className="text-white text-[17px] font-semibold">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="w-full px-[4rem] py-[5rem] bg-[#1A1A1A] text-center flex flex-col gap-[1.5rem] items-center">
        <div className="flex gap-[5px] justify-center">
          <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
          <p className="text-[18px] text-white">Ready to Find Your Next Property?</p>
        </div>
        <h2 className="text-[45px] font-bold text-gradient">Start Your Rental Search Today</h2>
        <p className="text-white text-[18px] font-light max-w-[800px]">
          Whether you're relocating, upgrading, or launching a business, Millennium Realty is here to help you find the right space in the Bay Area. Browse available rentals or contact our team to schedule a viewing today.
        </p>
        <div className="flex gap-[1rem] flex-wrap justify-center">
          <Buttons title="Browse Listings" width="200px" href="#listings" />
          <Link to="/contact">
            <button className="py-[0.8rem] px-[2rem] text-white font-semibold rounded-lg border border-[#EEC24B] hover:bg-[#EEC24B] hover:text-black transition-all duration-300">
              Contact Our Team
            </button>
          </Link>
        </div>
      </div>

    </div>
  );
};

export default Rent;
